import { getLocationPath, getMatchPath, getUrlParams, resolveCurrentRoute } from '../utils/routes-utils';
const ALLOWED_PARAMS = new Set(['appKey']);
export const getAnalyticsRouteParams = analyticsAttributes => {
  const locationPath = getLocationPath();
  const {
    mountPath
  } = analyticsAttributes;
  const currentRoute = resolveCurrentRoute(locationPath, mountPath);
  const routeParams = {};
  if (!currentRoute) {
    return routeParams;
  }
  const pathMatched = getMatchPath({
    locationPath,
    routePath: currentRoute.path,
    mountPath
  });
  if (!pathMatched) {
    return routeParams;
  }
  for (const key in pathMatched.params) {
    if (ALLOWED_PARAMS.has(key) && Object.prototype.hasOwnProperty.call(pathMatched.params, key) && pathMatched.params[key]) {
      routeParams[key] = pathMatched.params[key];
    }
  }
  return routeParams;
};
export const getAnalyticsSourceParam = () => {
  const {
    source
  } = getUrlParams();
  if (Array.isArray(source) && source.length) {
    return source[0].toString();
  }
  if (typeof source === 'string') {
    return source;
  }
};
export const getPageAttributes = (windowHref, documentReferrer) => {
  const page = windowHref ? new URL(windowHref) : null;
  const page_url = page ? page.href : '';
  const page_referrer = documentReferrer ? new URL(documentReferrer) : null;
  const pageAtrributes = {
    page_url,
    page_domain: page ? page.hostname : '',
    page_subdomain: page ? page.hostname : '',
    page_path: page ? page.pathname : '',
    page_url_parameters: page ? page.search : '',
    page_referrer_url: page_referrer ? page_referrer.href : '',
    page_referrer_domain: page_referrer ? page_referrer.hostname : '',
    page_referrer_subdomain: page_referrer ? page_referrer.hostname : '',
    page_referrer_path: page_referrer ? page_referrer.pathname : '',
    // EMCEE is in product experience, therefore `isMarketingEvent:false`, thread to follow for more clarity -> https://atlassian.slack.com/archives/C01U0UGBZJB/p1671134181487119
    isMarketingEvent: false
  };
  return pageAtrributes;
};